import React from 'react';
import classNames from 'classnames';
import PropTypes from 'prop-types';
import { withStyles } from '@material-ui/core/styles';

const styles = (theme) => ({
  container: {
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'center',
    justifyContent: 'center',
    backgroundColor: 'transparent',
    width: 'auto',
    height: '71px',
    marginLeft: '35px',
    color: '#666666',
    '&:hover': {
      cursor: 'pointer',
      color: '#004A8C',
    },
  },
  icon: {
    height: '14px',
    width: '14px',
    marginRight: '4px',
  },
  label: {
    fontSize: '14px',
  },
  hideInMobile: {
    [theme.breakpoints.down('xs')]: {
      display: 'none',
    },
  },
});

class TaxInvoiceAction extends React.Component {
  render = () => {
    const {
      classes,
      label,
      taxInvoice,
      onClick,
      icon,
      hideActionInMobile,
      hideIconInMobile,
    } = this.props;
    const Icon = icon;
    return (
      <div
        aria-hidden
        className={classNames(classes.container, {
          [classes.hideInMobile]: hideActionInMobile,
        })}
        onClick={(e) => onClick(e, taxInvoice)}>
        {Icon && (
          <Icon
            className={classNames(classes.icon, {
              [classes.hideInMobile]: hideIconInMobile,
            })}
          />
        )}
        <div className={classes.label}>{label}</div>
      </div>
    );
  };
}

TaxInvoiceAction.propTypes = {
  label: PropTypes.string,
  icon: PropTypes.object,
  taxInvoice: PropTypes.object,
  onClick: PropTypes.func,
  hideActionInMobile: PropTypes.bool,
  hideIconInMobile: PropTypes.bool,
  classes: PropTypes.object.isRequired,
};

export default withStyles(styles)(TaxInvoiceAction);
